// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gZw1","colMin":"styles_colMin__iKu4U"};